import { FC, useState } from "react";
import { WithChildren } from "../../../../../_metronic/helpers";
import {MyContext} from "./ContextFile";

export const ContextProvider : FC<WithChildren>=({ children }) => {
    const [state, setState] = useState({ 
      id: '', 
      code: '',
      description:'',
      discount_type: 'Percentage',
      discount_value: 0,
      min_purchase_amount: 0,
      max_discount_amount: 0,
      start_date: '',
      end_date: '',
      usage_limit: 0,
      status: 1,
      coupon_type: 1,
      plan_id: '' as number | string,
      editclicked: false 
    });
  
    return (
      <MyContext.Provider value={{state, setState  }}>
        {children}
      </MyContext.Provider>
    );
  };